import clsx from 'clsx';
import Logo from 'components/assets/lifepoints-logo.svg';
import { ReactElement, ReactNode } from 'react';
import A from '../A/A';
import Heading from '../Heading/Heading';
import Txt from '../Txt/Txt';
import classes from './RegistrationCard.module.scss';

export type Props = {
  title: string;
  withReportProblem?: boolean;
  className?: string;
  narrowContainer?: boolean;
  children: ReactNode;
  progressIndicator?: ReactNode;
  additionalInfo?: ReactNode;
  stepTitleClassName?: string;
  skipTitleTranslation?: boolean;
  hasUppercaseTitle?: boolean;
  hasCenteredTitle?: boolean;
  hideTitleOnMobile?: boolean;
  topIcon?: ReactNode;
};

export default function RegistrationCard({
  className,
  children,
  title,
  additionalInfo,
  withReportProblem,
  stepTitleClassName,
  skipTitleTranslation,
  hasUppercaseTitle,
  hasCenteredTitle,
  narrowContainer = false,
  hideTitleOnMobile,
  topIcon,
}: Props): ReactElement {
  return (
    <div>
      <div className={clsx(classes.root, className)}>
        <div
          className={clsx(
            classes.card,
            additionalInfo && classes.withAdditionalData,
            className,
            narrowContainer && classes.narrowContainer,
          )}
        >
          {additionalInfo && (
            <div className={clsx(classes.innerContainer, classes.additionalInfo)}>
              {additionalInfo}
            </div>
          )}

          <div className={clsx(classes.innerContainer, classes.content)}>
            {topIcon && <div className={classes.topIcon}>{topIcon}</div>}

            <Heading
              level={2}
              skipTranslation={skipTitleTranslation}
              className={clsx(
                classes.stepTitle,
                stepTitleClassName,
                hasUppercaseTitle && classes.hasUppercaseTitle,
                hasCenteredTitle && classes.hasCenteredTitle,
                hideTitleOnMobile && classes.hideTitleOnMobile,
              )}
            >
              {title}
            </Heading>
            {children}
            {withReportProblem && (
              <A className={classes.reportProblem} href="/member/zendeskhelp/new">
                <Txt>Report a problem</Txt>
              </A>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
